import { css, cx } from 'emotion';
import {
	pink,
	lightGrey,
	headingSmallLight,
	mobileMaxWidthBreakpoint,
	textBlock,
} from 'inside-out/global-styles';

const padding = 24;

export const wrapperStyle = css({
	position: 'relative',
	textDecoration: 'none',
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	padding: `${padding}px`,
	backgroundColor: '#fff',
	boxSizing: 'border-box',
	zIndex: '1',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: `14px`,
	},
});

export const titleStyle = cx(
	headingSmallLight,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '17px',
		},
	})
);

export const collaborationsStyle = cx(
	headingSmallLight,
	css({
		marginTop: padding / 2,
		color: pink,

		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '17px',
		},
	})
)

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: padding,
	})
);



// WEBPACK FOOTER //
// ./src/components/shared/cards/researchStaticCard/styles.js